import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { listSchedules } from '@/redux/requests/schedulesRequests.js';
import { listTriggers } from '@/redux/requests/triggersRequests.js';
import { listWorkflows } from '@/redux/requests/workflowsRequests.js';
import { activeCompanyId } from '@/redux/selectors/userSelectors.js';

/** Loads the organization's schedules, triggers and workflows when the section opens or the organization changes. */
const AutomationsStateHandler = () => {
  const companyId = useSelector(activeCompanyId);

  useEffect(() => {
    if (!companyId) {
      return;
    }

    listSchedules();
    listTriggers();
    listWorkflows();
  }, [companyId]);

  return null;
};

export default AutomationsStateHandler;
